<template>
  <Modal :title="$t('question.modals.confirmDeleteQuestion.title')" name="CONFIRM_DELETE_QUESTION" actions>
    <template v-slot:body>
      <p class="body-1 mb-1">
        {{ $t('question.modals.confirmDeleteQuestion.text') }}
      </p>
      <span class="d-block orange--text body-1 font-weight-bold">
        {{ question.label }}
      </span>
    </template>
    <template v-slot:actions>
      <v-btn @click="closeModal('CONFIRM_DELETE_QUESTION')" elevation="0" color="grey" class="mr-5" large text>
        {{ $t('question.modals.confirmDeleteQuestion.buttons.cancel') }}
      </v-btn>
      <v-btn @click="confirm" color="primary" elevation="0" large>
        {{ $t('question.modals.confirmDeleteQuestion.buttons.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'

import Modal from '@/components/app/Modal'

export default {
  name: 'ModalQuestionConfirmDelete',

  components: {
    Modal,
  },

  data() {
    return {
      question: null,
    }
  },

  methods: {
    ...mapActions(['closeModal', 'openModal']),

    openConfirmModal(question) {
      this.question = question
      this.openModal('CONFIRM_DELETE_QUESTION')
    },

    confirm() {
      this.$emit("confirm", this.question)
      this.closeModal('CONFIRM_DELETE_QUESTION')
    },
  },
}
</script>
